import { render, staticRenderFns } from "./TradeRecap.vue?vue&type=template&id=c2c8ccf4&"
import script from "./TradeRecap.vue?vue&type=script&lang=js&"
export * from "./TradeRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports